import React from 'react';
import { useAppSelector } from '@app/hooks/reduxHooks';
import { StyledBaseText, IStyledBaseTextProps } from './BaseText.styles';

interface IProps extends IStyledBaseTextProps {
  children: React.ReactNode;
}

export const BaseText = ({
  children,
  className,
  color = 'dark',
  weight = 'regular',
  size = 'md',
  textAlign = 'left',
  textOverflow = 'clip',
}: IProps) => {
  const theme = useAppSelector((state) => state.theme.theme);
  return (
    <StyledBaseText
      className={className}
      color={color}
      weight={weight}
      size={size}
      theme={theme}
      textAlign={textAlign}
      textOverflow={textOverflow}
    >
      {children}
    </StyledBaseText>
  );
};
